document.addEventListener("DOMContentLoaded", function () {
  // Let the document know when the mouse is being used
  document.body.addEventListener("mousedown", function () {
    document.body.classList.add("using-mouse")
  })

  // Re-enable focus styling when Tab is pressed
  document.body.addEventListener("keydown", function (event) {
    if (event.keyCode === 9) {
      document.body.classList.remove("using-mouse")
    }
  })

  // Predictive search header rework

  function getCombinedHeaderHeight() {
    const header = document.querySelector("#shopify-section-header")
    const topBar = document.querySelector("#shopify-section-announcement-bar")
    let combinedHeight = 0

    if (topBar) {
      combinedHeight = header.offsetHeight + topBar.offsetHeight
    } else {
      combinedHeight = header.offsetHeight
    }

    return combinedHeight
  }

  function predictiveSearchMediaQuery() {
    let root = document.documentElement

    if (window.matchMedia("(max-width: 576px)").matches) {
      const combinedHeaderHeight = getCombinedHeaderHeight()
      const viewportHeight = window.innerHeight
      const predictiveSearchResultsHeight =
        viewportHeight - combinedHeaderHeight

      root.style.setProperty(
        "--predictive-search-results-height-mobile",
        `${predictiveSearchResultsHeight}px`
      )
    }
  }

  predictiveSearchMediaQuery()

  window.addEventListener("resize", predictiveSearchMediaQuery)

  // Klaviyo

  class Newsletter {
    constructor(config = {}) {
      this.config = {
        klaviyoEndpoint:
          config.klaviyoEndpoint ||
          "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"
      }
      this.error = null
      this.success = false
      this.container = config.container
      this.form = this.container.querySelector("form")
      this.errorMessage = this.container.querySelector(
        "[data-newsletter-error]"
      )
      this.successMessage = this.container.querySelector(
        "[data-newsletter-success]"
      )
      this.events()
    }

    events() {
      this.form.addEventListener("submit", (e) => {
        e.preventDefault()
        this.postData()
      })
    }

    isEmailValid(email) {
      return /^.+@.+\..+$/.test(email)
    }

    async postData() {
      const email = this.form.querySelector('[name="contact[email]"]').value
      const source = this.form.querySelector('[name="source"]').value
      const listId = this.form.querySelector('[name="listId"]').value

      if (!this.isEmailValid(email)) {
        this.success = false
        this.error = "Please enter a valid email address"
        this.updateMessage()
        return false
      }

      let klaviyoPayload = new FormData()
      klaviyoPayload.append("g", listId)
      klaviyoPayload.append("email", email)
      klaviyoPayload.append("$timezone_offset", -7)
      klaviyoPayload.append("$source", source)
      klaviyoPayload.append("$fields", "$source")

      await axios
        .post(this.config.klaviyoEndpoint, klaviyoPayload)
        .then(() => {
          this.success = true
          this.error = null
        })
        .catch(() => {
          this.success = false
          this.error = "Sorry, please try again"
        })

      this.updateMessage()
    }

    updateMessage() {
      this.successMessage.style.display = "none"
      this.errorMessage.style.display = "none"

      if (this.success) {
        this.form.remove()
        this.successMessage.style.display = "block"

        let event = new CustomEvent("newsletter.subscribe")
        document.dispatchEvent(event)
      } else if (this.error) {
        this.errorMessage.innerText = this.error
        this.errorMessage.style.display = "block"
      }
    }
  }

  if (document.querySelector("[data-newsletter]") !== null) {
    const newsletterForms = document.querySelectorAll("[data-newsletter]")
    newsletterForms.forEach((container) => {
      new Newsletter({ container: container })
    })
  }

  // IGROOM-26-search-results-fix

  if (document.body.classList.contains('template-search')) {
    const sortBySelect = document.getElementById("SortBy")
    const filterArticleCheckboxEl = document.getElementById("Filter-article")
    const filterProductCheckboxEl = document.getElementById("Filter-product")

    function updateQueryStringParameter(uri, key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i")
      var separator = uri.indexOf("?") !== -1 ? "&" : "?"
      if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2")
      } else {
        return uri + separator + key + "=" + value
      }
    }

    let oldPushState = history.pushState
    history.pushState = function pushState() {
      let ret = oldPushState.apply(this, arguments)
      window.dispatchEvent(new Event("pushstate"))
      window.dispatchEvent(new Event("locationchange"))
      return ret
    }

    let oldReplaceState = history.replaceState
    history.replaceState = function replaceState() {
      let ret = oldReplaceState.apply(this, arguments)
      window.dispatchEvent(new Event("replacestate"))
      window.dispatchEvent(new Event("locationchange"))
      return ret
    }

    window.addEventListener("popstate", () => {
      window.dispatchEvent(new Event("locationchange"))
    })

    window.addEventListener("locationchange", function () {
      const params = new URLSearchParams(window.location.search)

      if (params.get("sort_by") == "relevance") {
        window.location.href = updateQueryStringParameter(
          window.location.href,
          "type",
          "article%2Cproduct"
        )
      } else {
        window.location.href = updateQueryStringParameter(
          window.location.href,
          "type",
          "product"
        )
      }
    })
  }

  // Igroom-30 FOUC Fix
  const foucEls = document.querySelectorAll('[igroom-fouc-fix]')

  foucEls.forEach((el) => {
    el.removeAttribute('igroom-fouc-fix')
  })

  //IGROOM-40 Change termly scroll events to account for sticky header
  window.addEventListener('message', (e) => {
       if (e.origin === 'https://app.termly.io') {
            const data = JSON.stringify(e.data)
            if (data.includes('scroll_to')) {
                 event.stopImmediatePropagation()
                 const stickyHeaderHeight = document.querySelector('#sticky-header-container').offsetHeight
                 const y_coord = parseInt(e.data.split('scroll_to:')[1]) - stickyHeaderHeight - 100
                 window.scrollTo(0, y_coord)
            }
       }
  })


})
